import React from 'react';
import { Table, Button, Space, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { ShippingRateTier } from '../../../../types/shipping-types';

interface RateTierTableProps {
    rateTiers: ShippingRateTier[];
    onAdd: () => void;
    onEdit: (tier: ShippingRateTier) => void;
    onDelete: (id: number) => void;
}

export const RateTierTable: React.FC<RateTierTableProps> = ({
    rateTiers,
    onAdd,
    onEdit,
    onDelete,
}) => {
    const columns: ColumnsType<ShippingRateTier> = [
        {
            title: '最小重量(kg)',
            dataIndex: 'min_weight',
            key: 'min_weight',
            width: 120,
        },
        {
            title: '最大重量(kg)',
            dataIndex: 'max_weight',
            key: 'max_weight',
            width: 120,
            render: (val) => val || '∞',
        },
        {
            title: '单价(¥/kg)',
            dataIndex: 'price_per_kg',
            key: 'price_per_kg',
            width: 120,
            render: (val) => `¥${val}`,
        },
        {
            title: '起步价(¥)',
            dataIndex: 'base_fee',
            key: 'base_fee',
            width: 120,
            render: (val) => `¥${val}`,
        },
        {
            title: '操作',
            key: 'action',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Button size="small" onClick={() => onEdit(record)}>编辑</Button>
                    <Button size="small" danger onClick={() => onDelete(record.id)}>删除</Button>
                </Space>
            ),
        },
    ];

    return (
        <Card
            title="运费阶梯"
            extra={
                <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
                    添加阶梯
                </Button>
            }
        >
            <Table
                columns={columns}
                dataSource={rateTiers}
                rowKey="id"
                pagination={false}
            />
        </Card>
    );
};
